import { BrowserRouter, Routes, Route } from "react-router-dom";
import Confirm from "./pages/Confirm";
import Deletesteps from "./pages/Deletesteps";
import Policy from "./pages/Policy";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";
import PasswordReset from "./pages/PasswordReset";
import PolicyProgBots from "./pages/PolicyProgbots";
import ProgBotsHome from "./pages/ProgBotsHome";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<ProgBotsHome />} />
        <Route path="confirm" element={<Confirm />} />
        <Route path="deletesteps" element={<Deletesteps />} />
        <Route path="policy" element={<Policy />} />
        <Route path="policyProgBots" element={<PolicyProgBots />} />
        <Route path="passwordreset" element={<PasswordReset />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
